export default {"src":"/_next/static/media/already-has-contractor.e5f3353c.svg","height":36,"width":33,"blurWidth":0,"blurHeight":0};